import mysql from "serverless-mysql"
import dotenv from "dotenv"

// needed to read the proper .env file, even when index.ts has it
dotenv.config()

const config = process.env.recipes_db_socket_path
	? {
			// socket path exists, production mode (linux)
			database: process.env.recipes_db_name,
			user: process.env.recipes_db_user,
			password: process.env.recipes_db_password,
			socketPath: process.env.recipes_db_socket_path,
		}
	: {
			// no socket path, development mode (windows)
			/* don't expose password or any sensitive info, done only for demo */
			host: "localhost",
			database: "recipes",
			user: "root",
			password: "",
			// connectionLimit: 50,
			port: 3306,
		}

const db = mysql({ config })

console.log(
	"Read database configuration as:\ndatabase: ",
	process.env.recipes_db_name,
	"\nuser: ",
	process.env.recipes_db_user,
	"\npassword: ",
	process.env.recipes_db_password,
	"\npassword length: ",
	process.env.recipes_db_password?.length,
	"\nsocketPath: ",
	process.env.recipes_db_socket_path,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default async function executeQuery({ query, values = "" }: { query: string; values?: string }): Promise<any> {
	// try {
	const results = await db.query(query, values)

	await db.end()

	return results
	// } catch (error) {
	// throw error;
	// }
}

// PATH: /etc/profile.d
// export varname=value
//
// startup status handled by update-rc.d (scriptname) defaults
